export const customTemplate = `
<div class="olap-wj-panel d-flex">
<div class="field-list-label d-none">
  <label wj-part="g-flds"></label>
</div>
<div class="field-list">
  <div class="fields-list-search-wrapper">
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.4142 10L13.9497 13.5355M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round"/>
    </svg>
    <input id="field-list-search-wrapper-input" class="field-list-search-wrapper-input" wj-part="input" type="text" placeholder="Поиск" />
    <svg class="fields-list-search-wrapper_clear-button d-none" width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" @click="clear">
      <path
        d="M0.325608 10.746C-0.0649162 10.3555 -0.0649162 9.72233 0.325608 9.33181L9.36312 0.292893C9.75364 -0.0976313 10.3868 -0.0976309 10.7773 0.292893C11.1679 0.683418 11.1679 1.31658 10.7773 1.70711L1.73982 10.746C1.3493 11.1365 0.716132 11.1365 0.325608 10.746Z"
      />
      <path
        d="M10.6836 10.6835C11.0741 10.293 11.0741 9.65986 10.6836 9.26933L1.70711 0.292893C1.31658 -0.0976313 0.683417 -0.0976309 0.292893 0.292893C-0.0976311 0.683418 -0.0976311 1.31658 0.292893 1.70711L9.26935 10.6835C9.65987 11.0741 10.293 11.0741 10.6836 10.6835Z"
      />
    </svg>
  </div>
  <div wj-part="d-fields">
    <div class="fields-list-search-no-fields-found d-none">Совпадений не найдено</div>
  </div>
</div>
<div class="drag-areas-label d-none">
  <label wj-part="g-drag"></label>
</div>
<div class="filter-list">
  <label class="mb-1">
    <span class="filter-list-label" wj-part="g-flt"></span>
  </label>
  <div wj-part="d-filters"></div>
</div>
<div class="column-list">
  <label class="mb-1">
    <span class="column-list-label" wj-part="g-cols"></span>
  </label>
  <div wj-part="d-cols"></div>
</div>
<div class="row-list pad bdr-top">
  <label class="mb-1">
    <span class="row-list-label" wj-part="g-rows"></span>
  </label>
  <div wj-part="d-rows"></div>
</div>
<div class="values-list bdr-left bdr-top">
  <label class="mb-1">
    <span class="values-list-label" wj-part="g-vals"></span>
  </label>
  <div wj-part="d-vals"></div>
</div>
<div wj-part="d-prog" class="progress-bar"></div>
<div class="control-area d-none">
  <label>
    <input wj-part="chk-defer" type="checkbox">
    <span wj-part="g-defer">Defer Updates</span>
  </label>
  <button wj-part="btn-update" class="wj-btn wj-state-disabled" type="button" disabled>
    Update
  </button>
</div>
</div>`;
